import React from 'react'
import WorkExperience from './WorkExperience'

const WorkExperienceMain = () => {
  return (
    <div id="workExperience" className="w-full min-h-10 dark:text-white">
      <WorkExperience />
    </div>
  )
}

export default WorkExperienceMain